import { FileTriggerProps } from 'components/FileTrigger/Types'
import { forwardRef } from 'react'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import { useObjectRef } from '@react-aria/utils'
import { PressResponder } from '@react-aria/interactions'

export const FileTrigger = forwardRef<HTMLInputElement, FileTriggerProps>(function FileTrigger(props, ref) {
  const {
    onSelect,
    accept,
    allowsMultiple,
    defaultCamera,
    children,
    isPressed,
    isDisabled,
    preventFocusOnPress,
    allowTextSelectionOnPress,
    shouldCancelOnPointerExit,
    ...rest
  } = props
  const inputRef = useObjectRef(ref)

  return (
    <>
      <PressResponder
        onPress={() => {
          if (inputRef.current?.value) {
            inputRef.current.value = ''
          }
          inputRef.current?.click()
        }}
        isDisabled={isDisabled}
        isPressed={isPressed}
        allowTextSelectionOnPress={allowTextSelectionOnPress}
        preventFocusOnPress={preventFocusOnPress}
        shouldCancelOnPointerExit={shouldCancelOnPointerExit}
      >
        {children}
      </PressResponder>
      <VisuallyHidden>
        <input
          {...rest}
          ref={inputRef}
          type="file"
          capture={defaultCamera}
          accept={accept?.toString()}
          multiple={allowsMultiple}
          onChange={(e) => onSelect?.(e.target.files)}
        />
      </VisuallyHidden>
    </>
  )
})
